import React, {Fragment, useState,useRef} from "react";
import {Button, Col, FormCheck, Modal, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import cogoToast from "cogo-toast";
import LoadingText from "../Loading/LoadingText";
import {useSelector} from "react-redux";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReactToPrint from "react-to-print";
import appUtility from "../../RestAPI/AppUtility";

export default function RevenueAnalyse(){
    let state=useSelector((state)=> state);
    const ref=useRef();
    const[Id, setId]=useState()
    const[Bin, setBin]=useState()
    const[Name, setName]=useState()
    const [Division, setDivision]=useState([]);
    const [Circle, setCircle]=useState([]);
    const [DataCoEffeciantRevenue, setDataCoEffeciantRevenue]=useState([]);
    const[DataStatus, setDataStatus]=useState(false);
    const [DataLength, setDatalength]=useState(0);
    const [ColumnCoEfficientRevenue, setColumnCoEfficientRevenue]=useState([{}]);

    const [showHistory, setShowHistory] = useState(false);
    const[History, setHistory]=useState([]);
    const handleCloseHistory = () => setShowHistory(false);
    const handleShowHistory = () =>setShowHistory(true);
    const [showEntry, setShowEntry] = useState(false);
    const handleCloseEntry = () => setShowEntry(false);
    const handleShowEntry = () => setShowEntry(true);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [DataReportRevenueHistory, setDataReportRevenueHistory]=useState([]);
    const [showReportRevenueHistory, setShowReportRevenueHistory] = useState(false);
    const handleCloseReportRevenueHistory = () => setShowReportRevenueHistory(false);
    const handleShowReportRevenueHistory = () => setShowReportRevenueHistory(true);
    const [ColumnReportRevenueHistory, setColumnReportRevenueHistory]=useState([{}]);
    const selectRowRevenue={
        mode:'radio',
        onSelect:(row,isSelect,rowIndex)=>{
            setId(row['ID']);
            setBin(row['Bin']);
            setName(row['Name']);
            handleShow();

        }
    }
    const getBIN=()=>{
        setDataStatus(true);
        setDatalength(0)
        const Commi=document.getElementById("cmbBinCommi");
        const CommiValue=Commi.options[Commi.selectedIndex].text;

        const Division=document.getElementById("cmbBinDivision");
        const DivisionValue=Division.options[Division.selectedIndex].text;


        const Circle=document.getElementById("cmbBinCircle");
        const CircleValue=Circle.options[Circle.selectedIndex].text;

        const Range=document.getElementById("cmbRange");
        const RangeValue=Range.options[Range.selectedIndex].text;

        const DepositParcent=document.getElementById("cmbDepositParcent");
        const DepositValue1=document.getElementById("txtDepositValue1").value;
        const DepositValue2=document.getElementById("txtDepositValue2").value;

        const Items=document.getElementById("cmbItems");
        const ItemsValue=Items.options[Items.selectedIndex].text;

        const DataLimit=document.getElementById("cmbDataLimit");
        const DataLimitValue=DataLimit.options[DataLimit.selectedIndex].text;

        const SearchBin=document.getElementById("txtSearchBin").value;
        const SearchName=document.getElementById("txtSearchName").value;



        const FY=document.getElementById("cmbFYRevenue");
        const FyValue=FY.options[FY.selectedIndex].text;

        const Month=document.getElementById("cmbMonth");
        const MonthValue=Month.options[Month.selectedIndex].text;

        const cmbStatus=document.getElementById("cmbStatus");
        const AmountStatus=document.getElementById("cmbAmountStatus");
        const StatusValue=document.getElementById("txtStatusValue").value;

        const BalanceRatio=document.getElementById("txtBalanceRatio").value;
        const PayableRatio=document.getElementById("txtPayableRatio").value;
        const BalanceVat=document.getElementById("cmbBalanceVat");
        const BalanceVatValue=document.getElementById("txtBalanceVat").value;
        const Flag=document.getElementById("cmbFlag");
        const Bond=document.getElementById("cmbBond");
        const ManualReturn=document.getElementById("cmbManualReturn");

        const CommissionerateCol=document.getElementById("cbCommissionerate").checked;
        const DivisionCol=document.getElementById("cbDivision").checked;
        const CircleCol=document.getElementById("cbCircle").checked;
        const RangeCol=document.getElementById("cbRange").checked;
        const CategoryCol=document.getElementById("cbCategory").checked;
        const MonthCol=document.getElementById("cbMonth").checked;
        const FYCol=document.getElementById("cbFY").checked;
        const TotalPayableSalesValue=document.getElementById("cbTotalSalesValue").checked;
        const TotalPayableSd=document.getElementById("cbTotalPayableSD").checked;
        const DecreasingAdj=document.getElementById("cbDecreasingAdj").checked;
        const IncreasingAdj=document.getElementById("cbIncreasingAdj").checked;
        const VdsIncrease=document.getElementById("cbVdsIncreasing").checked;
        const VdsDecrease=document.getElementById("cbVdsDecreasing").checked;
        const NetPayableVAT=document.getElementById("cbNetPayableVAT").checked;
        const NetPayableSD=document.getElementById("cbNetPayableSD").checked;
        const ClosingBalaceSD=document.getElementById("cbClosingBalanceSD").checked;
        const EconomicActivity=document.getElementById("cbEconomicActivity").checked;
        const NegativeStatus=document.getElementById("cbNegativeStatus").checked;
        const Debt=document.getElementById("cbDebt").checked;
        const FlagCol=document.getElementById("cbFlag").checked;
        const BondCol=document.getElementById("cbBond").checked;
        const ManualReturnCol=document.getElementById("cbReturn").checked;

        let getLimit="";
        let getCommi="";
        let getDivision="";
        let getCircle="";
        let getRange="";
        let getDepositParcent="";
        let getItems="";
        let getBin="";
        let getName="";
        let getStatusValue="";
        let getMonth="";
        let getFY="";
        let getBalanceRatio="";
        let getPayableRatio="";
        let getBalance="";
        let getFlag="";
        let getBond="";
        let getManualReturn="";

        if(state.accessCom=="NBR")
        {if(Commi.selectedIndex!=0){getCommi="And Commissionerate Like '%"+CommiValue+"%'"}}
        else{getCommi="And Commissionerate Like '%"+state.accessCom+"%'"}

        if(state.accessDiv=="All Division"){if(Division.selectedIndex!=0){getDivision="And Division Like '%"+DivisionValue+"%'"}}
        else{getDivision="And Division Like '%"+state.accessDiv+"%'"}

        if(state.accessCir=="All Circle"){if(Circle.selectedIndex!=0){getCircle="And Circle = '"+CircleValue+"'"}}
        else {getCircle="And Circle = '"+state.accessCir+"'"}

        if(Range.selectedIndex!=0){getRange="And Range_Name ='"+RangeValue+"'"}


        if(Items.selectedIndex!=0){getItems="And Category= '"+ItemsValue+"'"}
        if(SearchBin!=""){ getBin=" And BIN Like '%"+SearchBin+"%'"}
        if(SearchName!=""){ getName=" And Name Like '%"+SearchName+"%'"}
        if(FY.selectedIndex!=0){ getFY=" And FY = '"+FyValue+"'"}
        if(Month.selectedIndex!=0){ getMonth=" And Month = '"+MonthValue+"'"}
        if(BalanceRatio!=""){ getBalanceRatio=" And Balance_TR = '"+BalanceRatio+"'"}
        if(PayableRatio!=""){ getPayableRatio=" And Payable_TR = '"+PayableRatio+"'"}
        if(Flag.selectedIndex ==1){getFlag="And Flag >0"}
        if(Flag.selectedIndex ==2){getFlag="And Flag =0"}
        if(Flag.selectedIndex ==3){getFlag="And Flag =2"}
        if(Flag.selectedIndex ==4){getFlag="And Flag =3"}
        if(Flag.selectedIndex ==5){getFlag="And Flag =4"}

        if(ManualReturn.selectedIndex ==1){getManualReturn="And Online_Return =1"}
        if(ManualReturn.selectedIndex ==2){getManualReturn="And Online_Return =0"}

        if(DepositParcent.selectedIndex ==1){getDepositParcent="And `Deposite_%` ="+DepositValue1+" "}
        if(DepositParcent.selectedIndex ==2){getDepositParcent="And `Deposite_%` >"+DepositValue1+" "}
        if(DepositParcent.selectedIndex ==3){getDepositParcent="And `Deposite_%` <"+DepositValue1+" "}
        if(DepositParcent.selectedIndex ==4){getDepositParcent="And `Deposite_%` Between "+DepositValue1+" and "+DepositValue2+" "}

            if(cmbStatus.selectedIndex==0){
                if(AmountStatus.selectedIndex==0){getStatusValue="  And Deposited_Vat !=0 "}
                if(AmountStatus.selectedIndex==1){getStatusValue="  And Deposited_Vat ="+StatusValue+" "}
                if(AmountStatus.selectedIndex==2){getStatusValue="  And Deposited_Vat <="+StatusValue+" And Deposited_Vat !=0 "}
                if(AmountStatus.selectedIndex==3){getStatusValue="  And Deposited_Vat >="+StatusValue+"  "}
            }
            if(cmbStatus.selectedIndex==1){getStatusValue=" And Deposited_Vat =0 "}
            if(cmbStatus.selectedIndex==2){getStatusValue=""}



        if(BalanceVat.selectedIndex==1){getBalance="  And Closing_Balance_VAT ="+BalanceVatValue+" "}
        if(BalanceVat.selectedIndex==2){getBalance="  And Closing_Balance_VAT <="+BalanceVatValue+" And Closing_Balance_VAT !=0 "}
        if(BalanceVat.selectedIndex==3){getBalance="  And Closing_Balance_VAT >="+BalanceVatValue+"  "}

        if(Bond.selectedIndex ==1){ getBond=" And Bond_Licence =1 "}
        if(Bond.selectedIndex ==2){ getBond=" And Bond_Licence =0 "}

        let getCommissionerateCol="";
        let getDivisionCol="";
        let getCircleCol="";
        let getRangeCol="";
        let getCategoryCol="";
        let getMonthCol="";
        let getFYCol="";
        let getTotalSalesValueCol="";
        let getTotalPayableSdCol="";
        let getDecreasingAdjCol="";
        let getIncreasingAdjCol="";
        let getVdsIncreaseCol="";
        let getVdsDecreaseCol="";
        let getNetPayableVATCol="";
        let getNetPayableSDCol="";
        let getClosingBalaceSDCol="";
        let getEconomicActivityCol="";
        let getNegativeStatusCol="";
        let getDebtCol="";
        let getFlagCol="";
        let getBondCol="";
        let getManualReturnCol="";

        let jsonObject;



        if(CommissionerateCol==true){getCommissionerateCol=" , Commissionerate "}
        if(DivisionCol==true){getDivisionCol=" , Division "}
        if(CircleCol==true){getCircleCol=" , Circle "}
        if(RangeCol==true){getRangeCol=" , Range_Name "}
        if(CategoryCol==true){getCategoryCol=" , Category "}
        if(MonthCol==true){getMonthCol=" , Month "}
        if(FYCol==true){getFYCol=" , FY "}
        if(TotalPayableSalesValue==true){getTotalSalesValueCol=" , Total_Sales_Value "}
        if(TotalPayableSd==true){getTotalPayableSdCol=" , Total_Payable_SD "}
        if(DecreasingAdj==true){getDecreasingAdjCol=" , Decreasing_Adjustment "}
        if(IncreasingAdj==true){getIncreasingAdjCol=" , Increasing_Adjustment "}
        if(VdsIncrease==true){getVdsIncreaseCol=" , VDS_Increasing "}
        if(VdsDecrease==true){getVdsDecreaseCol=" , VDS_Decreasing "}
        if(NetPayableVAT==true){getNetPayableVATCol=" , Net_Payable_VAT "}
        if(NetPayableSD==true){getNetPayableSDCol=" , Net_Payable_SD "}
        if(ClosingBalaceSD==true){getClosingBalaceSDCol=" , Closing_Balance_SD "}
        if(EconomicActivity==true){getEconomicActivityCol=" , Economic_Activity "}
        if(NegativeStatus==true){getNegativeStatusCol=" , Neg_Status "}
        if(Debt==true){getDebtCol=" , Debt_Status "}
        if(FlagCol==true){getFlagCol=" , Flag "}
        if(BondCol==true){getBondCol=" , Bond_Licence "}
        if(ManualReturnCol==true){getManualReturnCol=" , Online_Return "}



        if(DataLimit.selectedIndex!=0){getLimit=" LIMIT " +DataLimitValue;
            jsonObject={"sql":"SELECT ID "+getCommissionerateCol+" "+getDivisionCol+" "+getCircleCol+" "+getRangeCol+" ,BIN,Name "+getEconomicActivityCol+" "+getCategoryCol+" "+getFYCol+" "+getMonthCol+",round(Closing_balance_vat/Deposited_vat,1)AS Balance_TR,round(Total_Payable_VAT/Deposited_vat,1)AS Payable_TR,`Deposite_%`,`Rebate_%`,`Decreasing_%`  "+getTotalSalesValueCol+" ," +
                    "Total_Payable_VAT "+getTotalPayableSdCol+" "+getNetPayableVATCol+",Deposited_VAT "+getNetPayableSDCol+",Deposited_SD ,Total_Input_Tax_Credit_VAT "+getDecreasingAdjCol+"" +
                    " "+getIncreasingAdjCol+",AT_Paid,Closing_Balance_VAT "+getClosingBalaceSDCol+" "+getVdsIncreaseCol+" "+getVdsDecreaseCol+" "+getNegativeStatusCol+" "+getDebtCol+" "+getFlagCol+" "+getBondCol+" "+getManualReturnCol+" FROM nbr.revenue_analyse_view where 1=1 " +
                    ""+getCommi+" "+getDivision+" "+getCircle+" "+getRange+" "+getItems+" "+getBin+" "+getName+" "+getStatusValue+" "+getMonth+" "+getFY+" "+getBalanceRatio+" "+getPayableRatio+" "+getBalance+" "+getFlag+" "+getBond+" "+getDepositParcent+" "+getManualReturn+" order by Month_Code Desc "+getLimit+" "}


        }else{getLimit=""
            jsonObject={"sql":" SELECT count(BIN) AS 'Total Data' FROM nbr.revenue_analyse_view where 1=1 " +
                    ""+getCommi+" "+getDivision+" "+getCircle+" "+getRange+" "+getItems+" "+getBin+" "+getName+" "+getMonth+" "+getFY+" "+getStatusValue+"  "+getBalanceRatio+" "+getPayableRatio+" "+getBalance+" "+getFlag+" "+getBond+" "+getDepositParcent+" "+getManualReturn+"  "}

        }


        if(DepositParcent.selectedIndex==1 && DepositValue1=="" || DepositParcent.selectedIndex==2 && DepositValue1=="" || DepositParcent.selectedIndex==3 && DepositValue1=="" || DepositParcent.selectedIndex==4 && DepositValue1=="" || DepositParcent.selectedIndex==4 && DepositValue2==""   ){cogoToast.error("Please Insert Value Deposit Parcentage")}else {}
        setColumnCoEfficientRevenue([{}]);setDataCoEffeciantRevenue([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{
            setDatalength(result.length)
            if(result==""){cogoToast.error("Data not found");setDataStatus(false)}else {
                await setColumnCoEfficientRevenue(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataCoEffeciantRevenue(result);

                result.map(async (ctr,index)=> {
                })
                setDataStatus(false)
            }
        }).catch(error=>{setDataStatus(false)});
    }

    const updateCategory=()=>{

        const ItemModel=document.getElementById("cmbItemsModel");
        const ItemModelValue=ItemModel.options[ItemModel.selectedIndex].text;

        if(ItemModel.selectedIndex==0){cogoToast.error("Please select Item Box")}else {
            RestClient.PostRequest(AppUrl.saveData, {"sql": "Update bin set Category='"+ItemModelValue+"' where Bin='"+Bin+"' "}).then(result => {
                if (result == 1) {
                    cogoToast.success("Data saved")

                } else {
                    cogoToast.error("Data not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });
        }

    }
    const updateRange=()=>{

        const RangeNo=document.getElementById("cmbRangeOption");
        const RangeNoValue=RangeNo.options[RangeNo.selectedIndex].text;

        if(RangeNo.selectedIndex==0){cogoToast.error("Please select Range")}else {
            RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Range_Name='"+RangeNoValue+"' where Bin='"+Bin+"' "}).then(result => {
                if (result == 1) {
                    cogoToast.success("Range saved")

                } else {
                    cogoToast.error("Range not saved")
                }
            }).catch(error => {
                cogoToast.error(error)
            });
        }

    }

    const saveFlag=()=>{
        const FlagYes=document.getElementById("cmbFlagYes");
        if(FlagYes.selectedIndex==0){cogoToast.error("Please Select Flag Criteria")}else {
        RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Flag="+FlagYes.selectedIndex+" where Bin='"+Bin+"' "}).then(result => {
            if (result == 1) {
                cogoToast.success("Flag saved")

            } else {
                cogoToast.error("Flag not saved")
            }
        }).catch(error => {
            cogoToast.error(error)
        });}


    }
    const saveFlagNo=()=>{


        RestClient.PostRequest(AppUrl.updateData, {"sql": "Update bin set Flag=0 where Bin='"+Bin+"' "}).then(result => {
            if (result == 1) {
                cogoToast.success("Flag has been removed")

            } else {
                cogoToast.error("Flag has not been removed")
            }
        }).catch(error => {
            cogoToast.error(error)
        });


    }
    const saveHistory=(status)=>{
        const TaskTitle=document.getElementById("cmbTaskTitle");
        const CategoryValue=TaskTitle.options[TaskTitle.selectedIndex].text;
        const history=document.getElementById("txtAreaDetailes").value;

        let jsonObject="";

        if(status==0){
            jsonObject={"sql": "Insert into bin_detailes (Id, BIN,Detailes,Entry_date,Entry_User)Values(NULL, '"+Bin+"','"+history+"','"+appUtility.getDate(new Date())+"','"+state.name+"') "};
            if(history==""){cogoToast.error("Please insert")}else{
                RestClient.PostRequest(AppUrl.saveData,jsonObject ).then(result => {
                    if (result == 1) {
                        cogoToast.success("Data saved")

                    } else {
                        cogoToast.error("Data not saved")
                    }
                }).catch(error => {
                    cogoToast.error(error)
                });}
        }else if(status==1){
            jsonObject={"sql": "Insert into Pending_Task (Id, BIN,Task,Start_Date,User)Values(NULL,'"+Bin+"','"+CategoryValue+"','"+appUtility.getDate(new Date())+"','"+state.name+"') "};

                RestClient.PostRequest(AppUrl.saveData,jsonObject ).then(result => {
                    if (result == 1) {
                        cogoToast.success("Data saved")

                    } else {
                        cogoToast.error("Data not saved")
                    }
                }).catch(error => {
                    cogoToast.error(error)
                });
        }



    }
    const getHistory=()=>{

        let jsonObject={"sql":" SELECT Id,Detailes FROM bin_detailes where BIN='"+Bin+"'  "};

        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                setHistory(result);
                setShowHistory(true);

            }
        }).catch(error=>{ });

    }

    const getRevenueHistory=(status)=>{
        let jsonObject="";
        if(status==0){
            jsonObject={"sql":" SELECT July_24,July_25,August_24,August_25,September_24,September_25,October_24,October_25,November_24,November_25,December_24,December_25,January_25,January_26,February_25,February_26,March_25,March_26,April_25,April_26,May_25,May_26,June_25,June_26" +
                    ",(July_24+August_24+September_24+October_24+November_24+December_24+January_25+February_25+March_25+April_25+May_25+June_25)As Total_Last_Year," +
                    "(July_25+August_25+September_25+October_25+November_25+December_25+January_26+February_26+March_26+April_26+May_26+June_26)As Total_Upto FROM nbr.revenue_25_26_view where BIN='"+Bin+"' "};

        }else if (status==1){
            jsonObject={"sql":" select FY,Month,round(Closing_balance_vat/Deposited_vat,1)AS Balance_TR,round(Total_Payable_VAT/Deposited_vat,1)AS Payable_TR,`Deposite_%`,`Rebate_%`,`Decreasing_%`,Total_Sales_Value,Total_Payable_Vat,Total_Payable_SD,Total_Input_Tax_Credit_Value,Total_Input_Tax_Credit_VAT,Increasing_Adjustment,Decreasing_Adjustment,Net_Payable_VAT,Net_Payable_SD,Deposited_VAT,Deposited_SD,Closing_Balance_VAT,Closing_Balance_SD,VDS_Increasing,VDS_Decreasing,AT_Paid,Online_Return from Revenue_Analyse_View where BIN='"+Bin+"' order by Month_Code Desc "};

        }else if(status==2){
            jsonObject={"sql":" select * from BIN where BIN='"+Bin+"' "};
        }else if(status==3){
            jsonObject={"sql":" SELECT HSCODE,Description As Description_Of_Goods,Supply_Qty,Supply_Unit As Unit,Rm_Price,Addition_Price,Addition_Parcentage AS 'Add_%',Total_Price,Entry_Date As 'Effect_Date',DATEDIFF(CURDATE(),Entry_Date) AS Total_Days,Entry_Date,Status,Sale_Category,Comments As Comments_for_goods FROM `Co_Efficient` where BIN='"+Bin+"' "};

        }else if(status==4){
            jsonObject={"sql":" SELECT Court,Mamla_No,Mamla_Year,Mamla_Type,Amount,Status from Mamla where BIN='"+Bin+"' "};

        }else if(status==5){
            jsonObject={"sql":" SELECT * from Debt_Report where BIN='"+Bin+"' "};

        }else if(status==6){
            jsonObject={"sql":" SELECT Id, Reasons from negative_bin where BIN='"+Bin+"' "};

        }else if(status==7){
            jsonObject={"sql":" SELECT Bill_year,Bill_Month,Consumption_Unit,Unit_Price AS price,Entry_Officer,Entry_Date from Electricity_Data where BIN='"+Bin+"' "};

        }else if(status==8){
            jsonObject={"sql":" SELECT Caller,Call_Date,Comments from Call_Data where BIN='"+Bin+"' "};

        }else if(status==9){
            jsonObject={"sql":" SELECT SMS_Date,SMS_Sender,SMS from SMS_Data where BIN='"+Bin+"' "};

        }


        setColumnReportRevenueHistory([{}]);setDataReportRevenueHistory([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                await setColumnReportRevenueHistory(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataReportRevenueHistory(result);

                handleShowReportRevenueHistory();

            }
        }).catch(error=>{ });

    }

    return(
        <Fragment>
            <div >
                <Row className="mt-2">

                    <Col lg={3}>
                        <div className="">
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">NBR</label></Col>
                                <Col lg={9}  xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbBinCommi"
                                            onChange={()=>{
                                                setDivision([]);
                                                setCircle([]);
                                                const e = document.getElementById("cmbBinCommi");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.division.filter(x => x.Commissionerate_Id==value);
                                                setDivision(dt)


                                            }}
                                    >
                                        <option >NBR</option>
                                        {
                                            state.commi.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Division</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbBinDivision"
                                            onChange={()=>{
                                                setCircle([])
                                                const e = document.getElementById("cmbBinDivision");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.circle.filter(x => x.Division_Id==value);
                                                setCircle(dt)


                                            }}
                                    >
                                        <option >All Division</option>

                                        {
                                            Division.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Circle</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbBinCircle" >
                                        <option >All Circle</option>

                                        {
                                            Circle.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }


                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Range</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbRange"  >
                                        <option >All Range</option>
                                        <option >Range-1</option>
                                        <option >Range-2</option>
                                        <option >Range-3</option>
                                        <option >Range-4</option>
                                        <option >Range-5</option>
                                        <option >Range-6</option>
                                        <option >Range-7</option>
                                        <option >No Range</option>
                                    </select>
                                </Col>

                            </Row>

                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Items</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbItems"  >
                                        <option value="0">All Items</option>
                                        {
                                            state.category.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }

                                    </select>
                                </Col>

                            </Row>

                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">BIN</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtSearchBin"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Name</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtSearchName"/>
                                </Col>

                            </Row>


                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">BOND</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbBond"  >
                                        <option >Both</option>
                                        <option >Yes</option>
                                        <option >No</option>
                                    </select>
                                </Col>

                            </Row>

                            <Row className="mt-2">
                                <Col lg={3}xs={3}><label className="text-primary fw-bold">Deposit_%</label></Col>
                                <Col lg={3}xs={3}>
                                    <select   className="float-start w-100 customfontsize" id="cmbDepositParcent"  >
                                        <option >All</option>
                                        <option >Equal</option>
                                        <option >More</option>
                                        <option >Less</option>
                                        <option >Between</option>
                                    </select>
                                </Col>
                                <Col lg={3}xs={3}><input className="w-75" type="text" id="txtDepositValue1"/></Col>
                                <Col lg={3}xs={3}><input className="w-75" type="text" id="txtDepositValue2"/></Col>
                            </Row>

                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-primary fw-bold">VAT_Paid</label></Col>
                                <Col lg={9}xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbStatus" >
                                        <option >Paid Only</option>
                                        <option >Not Paid</option>
                                        <option >Both</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-primary fw-bold">Amount</label></Col>
                                <Col lg={5}xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbAmountStatus"  >
                                        <option >All Amount</option>
                                        <option >Equal</option>
                                        <option >Less Than</option>
                                        <option >More Than</option>
                                    </select>
                                </Col>

                                <Col lg={1}xs={4}><input  type="text" id="txtStatusValue"/></Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Balance</label></Col>
                                <Col lg={5}xs={6}><label className="text-danger fw-bold">Ratio Month</label></Col>
                                <Col lg={1}xs={2}><input type="text" id="txtBalanceRatio"/></Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Payble</label></Col>
                                <Col lg={5}xs={6}><label className="text-danger fw-bold">Ratio TR</label></Col>
                                <Col lg={1}xs={2}><input  type="text" id="txtPayableRatio"/></Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-primary fw-bold">B_VAT</label></Col>
                                <Col lg={5}xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbBalanceVat"  >
                                        <option >All Amount</option>
                                        <option >Equal</option>
                                        <option >Less Than</option>
                                        <option >More Than</option>
                                    </select>
                                </Col>

                                <Col lg={1}xs={4}><input type="text" id="txtBalanceVat"/></Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Return</label></Col>
                                <Col lg={9}xs={8}>
                                    <select   className="float-start w-100 customfontsize" id="cmbManualReturn"  >
                                        <option >All</option>
                                        <option >Online</option>
                                        <option >Manual</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">FY</label></Col>
                                <Col lg={9}xs={8}>
                                    <select   className="float-start w-100 customfontsize" id="cmbFYRevenue">
                                        <option >All</option>
                                        <option >25-26</option>
                                        <option >24-25</option>
                                        <option >23-24</option>
                                        <option >26-27</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Month</label></Col>
                                <Col lg={9}xs={8}>
                                    <select   className="float-start w-100 customfontsize" id="cmbMonth">
                                        <option >All</option>
                                        <option >July</option>
                                        <option >August</option>
                                        <option >September</option>
                                        <option >October</option>
                                        <option >November</option>
                                        <option >December</option>
                                        <option >January</option>
                                        <option >February</option>
                                        <option >March</option>
                                        <option >April</option>
                                        <option >May</option>
                                        <option >June</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Flag</label></Col>
                                <Col lg={9}xs={8}>
                                    <select   className="float-start w-100 customfontsize" id="cmbFlag"  >
                                        <option >All</option>
                                        <option >Yes</option>
                                        <option >No</option>
                                        <option>High</option>
                                        <option>Medium</option>
                                        <option>Highest</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Data</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbDataLimit"  >
                                        <option >All</option>
                                        <option >100</option>
                                        <option >200</option>
                                        <option >500</option>
                                        <option >1000</option>
                                        <option >2000</option>
                                        <option >3000</option>
                                        <option >5000</option>
                                        <option >10000</option>
                                        <option >20000</option>
                                        <option >50000</option>


                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-4">
                                <Col lg={3} >

                                </Col>
                                <Col lg={9} >
                                    <button className="w-100 text-danger" onClick={getBIN} >Search</button>
                                </Col>


                            </Row>

                            <Row className="mt-4">
                                <Col lg={3} >

                                </Col>
                                <Col lg={9} >
                                    <label className="text-primary fs-5 mr-4">Data found: {DataLength}</label>
                                </Col>


                            </Row>



                        </div>
                    </Col>

                    <Col lg={9}>
                        <div className="overflow-scroll animated zoomIn purchaseMedium2Div">
                            {
                                DataStatus? <LoadingText/>
                                    :<BootstrapTable ref={ref} id="RevenueTable" selectRow={selectRowRevenue}  keyField='ID' data={DataCoEffeciantRevenue} columns={ColumnCoEfficientRevenue}></BootstrapTable>


                            }
                        </div>
                        <Row className="mb-2">


                            <Col lg={12}xs={12}>
                                <Row>
                                    <Col lg={2} xs={6}> <FormCheck label="Total_Sales_Value" id="cbTotalSalesValue"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Total_Payable_SD" id="cbTotalPayableSD"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Decreasing Adj" id="cbDecreasingAdj"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Increasing Adj" id="cbIncreasingAdj"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="VDS Decreasing" id="cbVdsDecreasing"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="VDS Increasing" id="cbVdsIncreasing"/></Col>
                                </Row>
                                <Row>
                                    <Col lg={2} xs={6}> <FormCheck label="Net Payable VAT" id="cbNetPayableVAT"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Net Payable SD" id="cbNetPayableSD"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Clsing Blanc SD" id="cbClosingBalanceSD"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Econo Activty" id="cbEconomicActivity"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Negative Status" id="cbNegativeStatus"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Debt" id="cbDebt"/></Col>

                                </Row>
                                <Row>
                                    <Col lg={2} xs={6}> <FormCheck label="Commissionerate" id="cbCommissionerate"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Division" id="cbDivision"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Circle" id="cbCircle"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Range" id="cbRange"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Category" id="cbCategory"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Month" id="cbMonth"/></Col>

                                </Row>
                                <Row>
                                    <Col lg={2} xs={6}> <FormCheck label="Fiscal Year" id="cbFY"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Flag" id="cbFlag"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Bond" id="cbBond"/></Col>
                                    <Col lg={2} xs={6}> <FormCheck label="Return Status" id="cbReturn"/></Col>


                                </Row>
                            </Col>



                        </Row>

                        <Row>


                            <Col lg={6}>
                                <hr/>
                                <Row>
                                    <Col lg={4}> <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button " table="RevenueTable" filename="Revenue Report" sheet="Revenue" buttonText="Download Excel"/>
                                    </Col>
                                    <Col lg={2}><ReactToPrint   trigger={()=><Button className="w-100 mt-1 " >Print</Button>} content={()=>ref.current}  />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>


                </Row>

            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{Name}</Modal.Title>


                </Modal.Header>
                <Modal.Body>
                    <div className="flex-column">

                        <select className="float-start me-2 w-50 customfontsize" id="cmbItemsModel"  >
                            <option value="0">All Items</option>
                            {
                                state.category.map((ctr,index)=>{
                                    return (
                                        <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                    )
                                })

                            }
                        </select>

                        <Button variant="primary" onClick={updateCategory}>
                            Save
                        </Button>
                        <hr/>
                        <select className="float-start me-2 w-50 customfontsize" id="cmbRangeOption"  >
                            <option >All Range</option>
                            <option >Range-1</option>
                            <option >Range-2</option>
                            <option >Range-3</option>
                            <option >Range-4</option>
                            <option >Range-5</option>
                            <option >Range-6</option>
                            <option >Range-7</option>
                        </select>

                        <Button variant="primary" onClick={updateRange}>Save</Button>
                    </div>
                    <hr/>


                </Modal.Body>
                <Modal.Footer>
                    <Button className="" variant="danger" onClick={()=>getRevenueHistory(0)} >Revenue History</Button> <label></label>
                    <Button className="" variant="primary" onClick={()=>getRevenueHistory(1)} >Revenue Analysis</Button>
                    <Button className="" variant="danger" onClick={()=>getRevenueHistory(2)} >Basic Info</Button>
                    <Button className="" variant="primary" onClick={()=>getRevenueHistory(3)} >4.3</Button>
                    <Button className="" variant="primary" onClick={()=>getRevenueHistory(4)} >Mamla</Button>
                    <Button className="" variant="primary" onClick={()=>getRevenueHistory(5)} >Debt</Button>
                    <Button className="" variant="primary" onClick={()=>getRevenueHistory(6)} >Negative Revenue</Button>
                    <Button className="" variant="primary" onClick={()=>getRevenueHistory(7)} >Electricity Bill</Button>
                    <Button className="" variant="primary" onClick={()=>getRevenueHistory(8)} >Call Log</Button>
                    <Button className="" variant="primary" onClick={()=>getRevenueHistory(9)} >SMS Log</Button>
                    <Button variant="danger" onClick={getHistory}>Show History</Button>
                    <Button variant="danger" onClick={handleShowEntry}>Entry History</Button>


                    <Button variant="danger" onClick={handleClose}>
                        Close
                    </Button>



                </Modal.Footer>
            </Modal>
            <Modal show={showEntry} onHide={handleCloseEntry}>
                <Modal.Header closeButton>

                    <label>History entry form</label>

                </Modal.Header>
                <Modal.Body>
                    <textarea className="text-area" id="txtAreaDetailes"></textarea>
                    <hr/>
                    <Button variant="success" onClick={saveFlag} >
                        Flag ? Yes
                    </Button>
                    <select id="cmbFlagYes">
                        <option>Select</option>
                        <option>Low</option>
                        <option>High</option>
                        <option>Medium</option>
                        <option>Highest</option>
                    </select>
                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseEntry}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={()=>saveHistory(0)} >
                        Save History
                    </Button>
                    <Button variant="danger" onClick={()=>saveHistory(1)} >
                        Mark Pending
                    </Button>
                    <select id="cmbTaskTitle">
                        <option>Other</option>
                        <option>Preventive</option>
                        <option>Check Return</option>
                        <option>Check 4.3</option>
                        <option>Check Import</option>
                    </select>

                    <Button variant="primary" onClick={saveFlagNo} >
                        Flag ? No
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showHistory} onHide={handleCloseHistory}>
                <Modal.Header closeButton>

                    <label>Detailes History</label>

                </Modal.Header>
                <Modal.Body>
                    {
                        History.map((ctr,index)=>{
                            return (
                                <div> <label>{ctr.Detailes}</label>
                                    <hr/>
                                </div>
                            )
                        })
                    }

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseHistory}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>
            <Modal show={showReportRevenueHistory} onHide={handleCloseReportRevenueHistory} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>{Name}</label>

                </Modal.Header>
                <Modal.Body className="scrollable-x">
                    <div className="wide-content">
                        {<BootstrapTable  keyField='Id'  data={DataReportRevenueHistory} columns={ColumnReportRevenueHistory}></BootstrapTable>}
                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseReportRevenueHistory}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>
        </Fragment>

    )
}
